import { type RouteConfig } from 'vue-router'

import { dispatchSplashScreen } from './splashScreen.store'

export const splashScreenRouter: RouteConfig[] = [
  {
    path: '/splashScreen',
    component: async () => import('./splashScreen.vue'),
    async beforeEnter(to, _from, next): Promise<void> {
      await dispatchSplashScreen('init')
      next()
    },
  },
]
